import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { env } from 'config/environment'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Doc } from 'page/catalog/BasicWelcomePage/Doc'
import { FooButton } from 'page/catalog/BasicWelcomePage/salaris/FooButton'
import { SalarisButton } from 'page/catalog/BasicWelcomePage/salaris/SalarisButton'
import { SpecialButton } from 'page/catalog/BasicWelcomePage/salaris/SpecialButton'
import { TimeoutModal } from 'page/catalog/BasicWelcomePage/TimeoutModal/TimeoutModal'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { SyntheticEvent, useEffect, useState } from 'react'
import { opt } from 'store/opt'
import { space } from 'util/typo'
import css from './BasicWelcomePage.module.scss'

export const BasicWelcomePage = observer(() => {
  const demo = useDemo()
  const welcome = demo.welcome!
  const { video, data, policy, button, color, background, ready, doc, timeout } = welcome
  const play = !env.development
  const [error, setError] = useState(false)
  const [width, setWidth] = useState<number>()
  const className = clsx(css.page, ready && css.ready)
  const welcomeButtonStyle = { color, background }

  useBodyScrollLock(true)

  useEffect(() => {
    setError(false)
    setWidth(undefined)
  }, [video])

  const onVideo = useLatestCallback((event: SyntheticEvent<HTMLElement>) => {
    const error = event.type === 'error'
    setError(error)
    const rect = event.currentTarget.getBoundingClientRect()
    setWidth(env.development ? undefined : error ? undefined : rect.width)
    welcome.ready = true
  })

  const onStart = useLatestCallback(() => {
    demo.startBasic()
  })

  const onClickPolicy = useLatestCallback((event: SyntheticEvent) => {
    event.preventDefault()
    welcome.doc = policy
  })

  const onClickData = useLatestCallback((event: SyntheticEvent) => {
    event.preventDefault()
    welcome.doc = data
  })

  return <Vertical className={className} pad={24} center>
    <Vertical className={css.content} gap={24} wide tall center>
      <Space className={css.main} wide spring center>
        {!error && <video src={video} autoPlay={play} loop muted
          onLoadedData={onVideo} onError={onVideo} />}
        {error && <Space className={css.text} center>
          <Typo size={48} semi>
            WELCOME
          </Typo>
        </Space>}
      </Space>

      <Space className={css.buttons} gap={24} width={width}>
        {opt.salaris ? <>
          <SalarisButton />
          <SpecialButton />
        </> : opt.foo ? <>
          <FooButton />
        </> : <Space className={css.button} style={welcomeButtonStyle} gap={16} center onClick={onStart}>
          <Typo size={32} one semi center>
            {button}
          </Typo>
        </Space>}
      </Space>

      <Space className={css.consent} center>
        <Typo size={24} center>
          Нажимая кнопку «Примерить» вы подтверждаете, что ознакомились с
          {space}
          <Space className={css.underline} onClick={onClickPolicy}>
            <Typo>политикой конфиденциальности</Typo>
          </Space>
          {space}
          и даете
          {space}
          <Space className={css.underline} onClick={onClickData}>
            <Typo>согласие на обработку персональных данных</Typo>
          </Space>
        </Typo>
      </Space>
    </Vertical>
    {doc && <Doc />}
    {!timeout.active && <TimeoutModal />}
  </Vertical>
})
